import React, { useState, useEffect, useRef } from 'react';
import { StateContext, PlanDataProvider } from '../common/contexts';
import { CONCEPT_A } from './plans_data';
import { Router, initialState } from './router';

const {
  plans_prebuild,
  plans_construct,
  concept_a_perk_groups,
  allPlansIncludeConcept,
  cores,
  PERK_PRICE,
  allPerksFlatten
} = CONCEPT_A;

const PlansBuilderA = () => {
  const timerRef = useRef(null);
  const [ path, setPath ] = useState(initialState);
  useEffect(() => {
    const main = document.querySelector(".main-content");
    main.className = `${main.className} -a`;
  }, []);
  const updatePath = (value) => {
    if (path === value) {
      setPath("Reset");
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setPath(value);
        timerRef.current = null;
      }, 0);
    } else {
      clearTimeout(timerRef.current);
      setPath(value);
    }
  };
  return (
    <PlanDataProvider.Provider
      value={ {
        plans_prebuild,
        plans_construct,
        perks: concept_a_perk_groups,
        allPlansInclude: allPlansIncludeConcept,
        cores,
        PERK_PRICE,
        allPerksFlatten
      } }
    >
      <StateContext.Provider value={ [ path, updatePath ] }>
        <Router />
      </StateContext.Provider>
    </PlanDataProvider.Provider>
  );
};

export default PlansBuilderA;
